import { useEffect, useState } from 'react';

const useThreshold = (threshold: number): boolean => {
  const [hold, setHold] = useState<boolean>(threshold !== 0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setHold(false);
    }, threshold);
    return () => {
      clearTimeout(timeout);
    };
  }, [threshold]);

  return hold;
};

export default useThreshold;
